
import { Sale } from "@/models/base";
import Vue from "vue";
import AppSelectSaleLayout from "@/components/SelectSaleLayout.vue";
import { PrintContext, SalePrintSettings } from "@/utils/sale-layouts/print-settings";
import { v4 } from "uuid";
import { ISelectItem } from "winfakt-vue-components";
import { SaleService } from "@/services/sale-service";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			layoutIds: [0],
			printContext: PrintContext.PRINT,
			isDuplicate: false,
			radioName: `${v4()}-print-context`,
			printProgress: undefined as number | undefined
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		},
		emitInsteadOfPrint: Boolean,
		defaultContext: {
			type: String as ()=>PrintContext
		}
	},
	computed: {
		title():{toString():string}{
			if (this.emitInsteadOfPrint){
				return this.sale.ComputedFriendlyID;
			}
			return `${this.sale.ComputedFriendlyID} ${this.$ct("common.print")}`;
		},
		confirmText():TranslateResult{
			if (this.emitInsteadOfPrint){
				return this.$ct("common.confirm");
			}
			return this.$ct("common.print");
		},
		radioButtons():ISelectItem<PrintContext>[] {
			return [
				{
					text: this.$ct("print-with-print-settings"),
					value: PrintContext.PRINT
				},
				{
					text: this.$ct("print-with-download-settings"),
					value: PrintContext.DOWNLOAD
				},
				{
					text: this.$ct("print-with-mail-settings"),
					value: PrintContext.EMAIL_SEND
				}
			];
		},
		buttonsDisabled():boolean {
			return this.printProgress !== undefined;
		}
	},
	watch: {
		sale: {
			immediate: true,
			handler(){
				this.layoutIds = [this.sale.getLayoutID(this.printContext)];
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async emit(){
			try{
				this.printProgress = 0;
				let settings = new SalePrintSettings(this.printContext);
				settings.isDuplicate = this.isDuplicate;
				let done = 0;
				let result:File[] = [];
				for (let id of this.layoutIds) {
					let blob = await SaleService.downloadSale(this.sale, id, settings);
					let fileName = await SaleService.getSaleFileName(this.sale, id);
					let file = new File([blob], fileName, {type: blob.type});
					result.push(file);
					done++;
					this.printProgress = (done/this.layoutIds.length)*100;
				}
				this.$emit("files", result);
				this.close();
			}catch(err){
				this.printProgress = undefined;
			}
		},
		async print(){
			if (this.emitInsteadOfPrint){
				this.emit();
				return;
			}
			try{
				this.printProgress = 0;
				let settings = new SalePrintSettings(this.printContext);
				settings.isDuplicate = this.isDuplicate;
				let done = 0;
				for (let id of this.layoutIds) {
					await SaleService.printSale(this.sale, id, settings);
					done++;
					this.printProgress = (done/this.layoutIds.length)*100;
				}
				this.$emit("printed");
				this.close();
			}catch(err){
				this.printProgress = undefined;
			}
		},
	},
	mounted(){
		if (this.defaultContext){
			this.printContext = this.defaultContext;
		}
	},
	components: {
		AppSelectSaleLayout
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
